var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-menu",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function fn(_ref) {
                var on = _ref.on,
                  attrs = _ref.attrs
                return [
                  _c(
                    "gg-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            id: "filter-activator"
                          }
                        },
                        "gg-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._t("button-prepend"),
                      _vm._v(" Filter "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "ml-1",
                          attrs: {
                            small: ""
                          }
                        },
                        [_vm._v(" mdi-chevron-down ")]
                      )
                    ],
                    2
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      },
      "v-menu",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-list",
        {
          staticClass: "py-2"
        },
        [
          _vm.isNested
            ? _vm._l(_vm.items, function(filterItem, index) {
                return _c(
                  "v-list-item",
                  {
                    key: index,
                    staticStyle: {
                      display: "block"
                    }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "d-block pt-3 pb-0 uppercase",
                        staticStyle: {
                          "font-size": "14px"
                        }
                      },
                      [_vm._v(" " + _vm._s(filterItem.label) + " ")]
                    ),
                    _c(
                      "v-list-item-group",
                      {
                        attrs: {
                          multiple: ""
                        },
                        on: {
                          change: _vm.changedSelection
                        },
                        model: {
                          value: _vm.selectedItems,
                          callback: function callback($$v) {
                            _vm.selectedItems = $$v
                          },
                          expression: "selectedItems"
                        }
                      },
                      _vm._l(filterItem.items, function(item) {
                        return _c("v-list-item", {
                          key: item.value,
                          staticClass: "pa-0 mr-4",
                          staticStyle: {
                            "min-height": "24px",
                            "line-height": "20px"
                          },
                          attrs: {
                            value: item.value
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function fn(_ref2) {
                                  var active = _ref2.active
                                  return [
                                    _c(
                                      "v-list-item-action",
                                      {
                                        staticClass: "mr-4 my-1 pl-0"
                                      },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            "input-value": active,
                                            color: "primary"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      {
                                        staticClass: "py-1",
                                        staticStyle: {
                                          width: "max-content"
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.label))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              })
            : [
                _c(
                  "v-list-item",
                  [
                    _c(
                      "v-list-item-group",
                      {
                        attrs: {
                          multiple: ""
                        },
                        on: {
                          change: _vm.changedSelection
                        },
                        model: {
                          value: _vm.selectedItems,
                          callback: function callback($$v) {
                            _vm.selectedItems = $$v
                          },
                          expression: "selectedItems"
                        }
                      },
                      _vm._l(_vm.items, function(item) {
                        return _c("v-list-item", {
                          key: item.value,
                          staticClass: "pa-0 mr-4",
                          staticStyle: {
                            "min-height": "24px",
                            "line-height": "20px"
                          },
                          attrs: {
                            value: item.value
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function fn(_ref3) {
                                  var active = _ref3.active
                                  return [
                                    _c(
                                      "v-list-item-action",
                                      {
                                        staticClass: "mr-4 my-1 pl-0"
                                      },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            "input-value": active,
                                            color: "primary"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      {
                                        staticClass: "py-1",
                                        staticStyle: {
                                          width: "max-content"
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.label))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }